import ReactDOM from 'react-dom/client';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import './styles/index.css';
import LandingPage from './screens/LandingScreen';
import PrivatePolicy from './screens/PrivatePolicyScreen';
import Support from './screens/SupportScreen';
import reportWebVitals from './reportWebVitals';
import PageNotFound from './screens/PageNotFoundScreen';
import Download from './screens/DownloadScreen'
import Contact from './screens/ContactScreen';
import Entreprise from './screens/EntrepriseScreen'
import './styles/global.css';

const ExternalRedirect = ({ url }) => {
  window.location.href = url;
  return null;
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <LandingPage />,
  },
  {
    path: "/android",
    element: <ExternalRedirect url="https://play.google.com/store/apps/details?id=com.frdev.qalmo" />,
  },
  {
    path: "/confidentialite",
    element: <PrivatePolicy />,
  },
  {
    path: "/ios",
    element: <ExternalRedirect url="https://apps.apple.com/fr/app/qalmo/id6502453401" />,
  },
  {
    path: "/support",
    element: <Support />,
  },
  {
    path: "/download",
    element: <Download />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/entreprise",
    element: <Entreprise />
  },
  {
    path: "*",
    element: <PageNotFound />
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
    <RouterProvider router={router} />
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
